import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { MixedWidget100 } from '../mixed/MixedWidget100'

type Props = {
  className: string
  data?: any
}

const TablesWidget9: React.FC<Props> = ({ className, data }) => {
  const supplyChainData = data?.supplyChainWiseDataList || data || []

  const transformMonthWiseData = (monthData: any) => {
    if (!monthData || Object.keys(monthData).length === 0) return {}

    const transformed: any = {}
    Object.entries(monthData).forEach(([key, value]) => {
      const [month, year] = key.split('/')
      const monthNum = parseInt(month)
      if (monthNum >= 1 && monthNum <= 12 && year) {
        const date = new Date(parseInt(year), monthNum - 1, 1)
        const formattedKey = date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' })
        transformed[formattedKey] = value
      }
    })
    return transformed
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>My sponsored hubs</span>
          <span className='text-dark mt-1 fw-semibold fs-7'>Material Hub performance overview</span>
        </h3>
      </div>

      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead className="custom-waste-dashboard-thead">
              <tr className='fw-bold text-dark'>
                <th className='min-w-200px'>Material Hub</th>
                <th className='min-w-200px'>Connected households</th>
                <th className='min-w-150px'>Plastic collected</th>
                <th className='min-w-80px'>Trend</th>
              </tr>
            </thead>

            <tbody>
              {supplyChainData.map((item: any, index: number) => {
                // Get customer breakup for this specific pickup point
                const customerBreakup = item.customerBreakup || []
                const firstFiveCustomers = customerBreakup.slice(0, 5)
                const totalCustomerCount = item.customerCount || 0

                return (
                  <tr key={item.pickupPointId || index}>
                    <td>
                      <span className='text-dark fw-bold text-hover-primary fs-6'>
                        {item.pickupPointName?.trim() || 'N/A'}
                      </span>
                    </td>
                    <td>
                      <div style={{
                        display: 'flex',
                        position: 'relative',
                        gap: 0
                      }}>
                        {firstFiveCustomers.map((customer: any, idx: number) => (
                          <img
                            key={customer.customerId}
                            src={customer?.profile?.[0]?.docUrl || '/media/svg/avatars/blank.svg'}
                            alt={customer?.customerName}
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              border: '3px solid white',
                              marginLeft: idx === 0 ? 0 : '-14px',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                              objectFit: 'cover',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              display: 'block',
                              zIndex: idx + 1
                            }}
                            title={customer?.customerName}
                            onMouseEnter={(e) => {
                              (e.target as HTMLImageElement).style.transform = 'scale(1.2) translateY(-2px)'
                                ; (e.target as HTMLImageElement).style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'
                            }}
                            onMouseLeave={(e) => {
                              (e.target as HTMLImageElement).style.transform = 'scale(1) translateY(0)'
                                ; (e.target as HTMLImageElement).style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)'
                            }}
                          />
                        ))}
                        {totalCustomerCount > 0 && (
                          <div
                            onClick={() => {
                              window.location.pathname = '/apps/Changemakers'
                            }}
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              backgroundColor: '#0d6efd',
                              border: '3px solid white',
                              marginLeft: '-14px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '13px',
                              fontWeight: '700',
                              color: '#ffffff',
                              boxShadow: '0 2px 8px rgba(13, 110, 253, 0.3)',
                              cursor: 'pointer',
                              zIndex: 100,
                              transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                              (e.currentTarget as HTMLDivElement).style.transform = 'scale(1.2) translateY(-2px)'
                                ; (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 12px rgba(13, 110, 253, 0.4)'
                            }}
                            onMouseLeave={(e) => {
                              (e.currentTarget as HTMLDivElement).style.transform = 'scale(1) translateY(0)'
                                ; (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(13, 110, 253, 0.3)'
                            }}
                          >
                            {totalCustomerCount}
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <span className='fw-bold d-block fs-7'>
                        {item.quantity || 0} kg
                      </span>
                    </td>
                    <td style={{ maxWidth: '200px' }}>
                      <MixedWidget100
                        className=""
                        chartColor="primary"
                        chartHeight="40px"
                        title=""
                        subtitle=""
                        amount=""
                        chartData={transformMonthWiseData(item.monthWiseCollected)}
                        seriesName="Quantity"
                      />
                    </td>
                  </tr>
                )
              })}

              {supplyChainData.length === 0 && (
                <tr>
                  <td colSpan={4} className='text-center py-5'>
                    <div className='text-dark'>No pickup point data available</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export { TablesWidget9 }